import { useState, useEffect } from 'react';
import './PhoneNumber.css';
import UsFlag from '../../Images/US.png';
import CaFlag from '../../Images/Canada.png';
import { Dropdown, DropdownButton, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

const PhoneNumber = ({ onPhoneNumberChange, disabled, submitted, phoneError, value }) => {
  const [country, setCountry] = useState({ code: '+1', flag: UsFlag });
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (submitted && phoneError) {
      setShowError(true);
    }
  }, [submitted, phoneError]);

  useEffect(() => {
    if (value.startsWith(country.code)) {
      const phoneNumber = value.substring(country.code.length);
      onPhoneNumberChange(country.code + phoneNumber);
    }
  }, [value, country.code, onPhoneNumberChange]);

  const handleCountryChange = (country) => {
    let newCountry = { code: '+1', flag: UsFlag };
    if (country === 'CA') {
      newCountry = { code: '+1', flag: CaFlag };
    }
    setCountry(newCountry);
    if (value.startsWith(newCountry.code)) {
      onPhoneNumberChange(newCountry.code + value.substring(newCountry.code.length));
    } else {
      onPhoneNumberChange(newCountry.code + value);
    }
  };

  const handlePhoneNumberChange = (event) => {
    const phoneNumber = event.target.value.replace(/\D/g, '');
    if (phoneNumber) {
      onPhoneNumberChange(country.code + phoneNumber);
    } else {
      onPhoneNumberChange('');
    }
    if (phoneNumber !== '') {
      setShowError(false);
    }
  };

  return (
    <div className={`phone-number-component ${disabled ? 'disabled' : ''}`}>
      <div className='label-line'>
        <Form.Label className="phone-label">
          Phone Number*
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="sms-info-tooltip">SMS contact only upon request</Tooltip>}
          >
            <span className="info-icon" style={{ marginLeft: '5px', cursor: 'pointer' }}>ⓘ</span>
          </OverlayTrigger>
        </Form.Label>
        {showError && <div className="invalid-feedback" style={{ display: 'block' }}>{phoneError}</div>}
      </div>
      <div className={`phone-input-wrapper ${disabled ? 'phone-input-wrapper-disabled' : ''}`}>
        <DropdownButton
          disabled={disabled}
          id="dropdown-basic-button"
          title={
            <span className="country-code-wrapper">
              <img src={country.flag} alt="flag" className="flag-icon" /> <span className="country-code">{country.code}</span>
            </span>
          }
          className="country-dropdown"
          variant="link"
        >
          <Dropdown.Item onClick={() => handleCountryChange('US')}>
            <img src={UsFlag} alt="US flag" className="flag-icon" /> +1
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleCountryChange('CA')}>
            <img src={CaFlag} alt="Canada flag" className="flag-icon" /> +1
          </Dropdown.Item>
        </DropdownButton>
        <Form.Control
          type="text"
          value={value.startsWith(country.code) ? value.substring(country.code.length) : value}
          onChange={handlePhoneNumberChange}
          className="phone-input"
          disabled={disabled}
          isInvalid={showError}
        />
      </div>
    </div>
  );
};

export default PhoneNumber;
